{
  "Accessibility Menu": "Menuya Gihîştinê",
  "Reset settings": "Mîhengên vegerandinê",
  "Close": "Bigire",
  "Content Adjustments": "Guhertinên Naverokê",
  "Adjust Font Size": "Mezinahiya Fontê biguherîne",
  "Highlight Title": "Sernavê nîşan bide",
  "Highlight Links": "Girêdanên nîşan bide",
  "Readable Font": "Fonta Xwendinê",
  "Color Adjustments": "Guhertinên Rengê",
  "Dark Contrast": "Pêvajoya Tarî",
  "Light Contrast": "Pêvajoya Ronahî",
  "High Contrast": "Pêvajoya Bilind",
  "High Saturation": "Tevgeriya Bilind",
  "Low Saturation": "Tevgeriya Nizm",
  "Monochrome": "Rengê Yekane",
  "Contrast": "Kontrast",
  "Invert Colors": "Rengên vegerîne",
  "Tools": "Amûr",
  "Reading Guide": "Rehbera Xwendinê",
  "Stop Animations": "Anîmasyonan Rawestîne",
  "Big Cursor": "Kursorê Mezin",
  "Increase Font Size": "Mezinahiya Fontê Mezinkirin",
  "Decrease Font Size": "Mezinahiya Fontê Kêmkirin",
  "Letter Spacing": "Dûrahiya Tîpan",
  "Line Height": "Bilindahiya Rêzê",
  "Font Weight": "Giraniya Fontê",
  "Dyslexia Font": "Fonta Disleksiya",
  "Language": "Ziman",
  "Open Accessibility Menu": "Menuya Gihîştinê Vekirî",
  "Widget Settings": "Mîhengên widgetê",
  "Widget Position": "Pozîsyona widgetê",
  "Top Left": "Serrê çep",
  "Top Center": "Serrê navîn",
  "Top Right": "Serrê rast",
  "Center Left": "Navendê çep",
  "Center Right": "Navendê rast",
  "Bottom Left": "Binê çep",
  "Bottom Center": "Binê navîn",
  "Bottom Right": "Binê rast",
  "Screen Reader": "Xwendekara dîmenderê",
  "Voice Navigation": "Rêberiya dengî",
  "Custom Color": "Renga taybet",
  "Change the site's colors": "Rengên malperê biguherîne",
  "Backgrounds": "Paşperde",
  "Headings": "Sernav",
  "Contents": "Naverok",
  "Reset colors": "Rengên vegerîne",
  "Image Desaturation": "Nermkirina renga wêneyê",
  "Search languages": "Zimanên bigere",
  "No languages found": "Tu ziman nehat dîtin",
  "Accessibility Profiles": "پرۆفایلەکانی دەستگەیشتن",
  "Motor Impaired": "کێشەی هەنگاو",
  "Big cursor, voice navigation, and no animations.": "کرسرێکی گەورە، ڕێنیشاندانی دەنگ و بێ ئانیمەیشن.",
  "Blind": "کوێر",
  "Screen reader helpers with higher contrast.": "یارمەتی خوێنەری شاشە بە کونتراستی بەرز.",
  "Color Blind": "کێشەی ڕەنگ",
  "High contrast palette with desaturated media.": "پالێتی کونتراستی بەرز بە میدیا کەمدەڕەوشاو.",
  "Dyslexia": "دیسلەکسیا",
  "Friendly font, extra spacing, stronger weight.": "فۆنتی هاوبەش، بۆشایی زیاتر و قەڵەوی بەرزتر.",
  "Low vision": "بینینی لاواز",
  "Dark contrast and 130% magnification.": "کۆنترستی تاریک و گەورەکردنی ١٣٠٪‏.",
  "Cognitive & Learning": "ئەستێرەی هەستکردن و فێربوون",
  "Highlights key sections and enables voice help.": "بەشە گرنگەکان پیشان دەدات و یارمەتی دەنگی چالاک دەکات.",
  "Seizure & Epileptic": "دەستپێکردن و ئەپیلەپسی",
  "Stops animations and desaturates imagery.": "ئانیمەیشن وێنەکانی وەستێنێت و ڕەنگیان کەم دەکات.",
  "ADHD": "ADHD",
  "Reading guide, highlighted links, calmer palette.": "ڕێبەری خوێندن، بەستەرە دیاربکراوەکان و پالێتی ئارام.",
  "Widget Size": "Widget Size",
  "Default": "Default",
  "Medium": "Medium",
  "Small": "Small",
  "Color Blindness": "Color Blindness",
  "Protanopia": "Protanopia",
  "Deuteranopia": "Deuteranopia",
  "Tritanopia": "Tritanopia",
  "Achromatopsia": "Achromatopsia",
  "Simulates and assists users with color vision deficiencies.": "Simulates and assists users with color vision deficiencies."
}
